module.exports = __webpack_public_path__ + "img/elementheights_jasp.dc2fa62c.png";